import { doctorRoutes, doctorSecondaryRoutes } from './doctorRoutes';
// import teamRoutes from './teamRoutes'; // ? What is team routes?

export const routes = doctorRoutes;
export const resourceRoutes = doctorSecondaryRoutes;
